export default __webpack_public_path__ + "static/media/painting16.ee906fdb.jpg";